import React from 'react'
import PropTypes from 'prop-types'
import { Info } from 'react-feather'
const ShowError = ({ error, touched }) =>
  touched && error ? (
    <div className="error">
      <Info style={{ position: 'relative', top: -2, marginRight: 2 }} />
      {error}
    </div>
  ) : null

ShowError.propTypes = {
  error: PropTypes.string,
  touched: PropTypes.bool
}

export default ShowError
